<template>
<div class="chapter">
<div class="inner_page">
<p class="OT" id="abb"><a id="page_xiii"></a><a href="#/xhtml/contents#abb">Abbreviations</a></p>
<table cellpadding="0" cellspacing="0" class="abbre">
<tbody><tr>
<td><i>AB</i></td>
<td><i>Anchor Bible</i></td>
</tr>
<tr>
<td><i>ATR</i></td>
<td><i>Anglican Theological Review</i></td>
</tr>
<tr>
<td><i>AUSS</i></td>
<td><i>Andrews University Seminary Studies</i></td>
</tr>
<tr>
<td>BAGD</td>
<td>W. Bauer, W. F. Arndt, F. W. Gingrich, and F. W. Danker, <i>A Greek-English Lexicon of the NT and Other Early Christian Literature</i> (Chicago, 1979<sup>2</sup>)</td>
</tr>
<tr>
<td><i>BBR</i></td>
<td><i>Bulletin for Biblical Research</i></td>
</tr>
<tr>
<td><i>Bib</i></td>
<td><i>Biblica</i></td>
</tr>
<tr>
<td><i>BibRev</i></td>
<td><i>Bible Review</i></td>
</tr>
<tr>
<td><i>BibSac</i></td>
<td><i>Bibliotheca Sacra</i></td>
</tr>
<tr>
<td><i>BJRL</i></td>
<td><i>Bulletin of the John Rylands Library</i></td>
</tr>
<tr>
<td><i>BR</i></td>
<td><i>Biblical Research</i></td>
</tr>
<tr>
<td><i>BTB</i></td>
<td><i>Biblical Theology Bulletin</i></td>
</tr>
<tr>
<td><i>CBQ</i></td>
<td><i>Catholic Biblical Quarterly</i></td>
</tr>
<tr>
<td><i>CJTh</i></td>
<td><i>Canadian Journal of Theology</i></td>
</tr>
<tr>
<td><i>CTJ</i></td>
<td><i>Calvin Theological Journal</i></td>
</tr>
<tr>
<td><i>CurTM</i></td>
<td><i>Currents in Theology and Mission</i></td>
</tr>
<tr>
<td><i>DCG</i></td>
<td><i>Dictionary of Christ and the Gospels</i> (Hastings)</td>
</tr>
<tr>
<td><i>DJG</i></td>
<td><i>Dictionary of Jesus and the Gospels</i></td>
</tr>
<tr>
<td><i>EQ</i></td>
<td><i>Evangelical Quarterly</i></td>
</tr>
<tr>
<td><i>ET</i></td>
<td><i>Expository Times</i></td>
</tr>
<tr>
<td><i>EvTh</i></td>
<td><i>Evangelische Theologie</i></td>
</tr>
<tr>
<td><i>Greg</i></td>
<td><i>Gregorianum</i></td>
</tr>
<tr>
<td><i>HDB</i></td>
<td><i>Hastings’ Dictionary of the Bible</i></td>
</tr>
<tr>
<td><i>HERE</i></td>
<td><i>Encyclopedia of Religion and Ethics</i> (Hastings)</td>
</tr>
<tr>
<td><i>HorBT</i></td>
<td><i>Horizons in Biblical Theology</i></td>
</tr>
<tr>
<td><i>HTR</i></td>
<td><i>Harvard Theological Review</i></td>
</tr>
<tr>
<td><i>HUCA</i></td>
<td><i>Hebrew Union College Annual</i></td>
</tr>
<tr>
<td><i>IB</i></td>
<td><i>Interpreter’s Bible</i></td>
</tr>
<tr>
<td><i><a id="page_xiv">ICC</a></i></td>
<td><i>International Critical Commentary</i></td>
</tr>
<tr>
<td><i>IDB</i></td>
<td><i>Interpreter’s Dictionary of the Bible</i></td>
</tr>
<tr>
<td><i>Int</i></td>
<td><i>Interpretation</i></td>
</tr>
<tr>
<td><i>ISBE</i></td>
<td><i>International Standard Bible Encyclopedia</i></td>
</tr>
<tr>
<td><i>JBL</i></td>
<td><i>Journal of Biblical Literature</i></td>
</tr>
<tr>
<td><i>JBR</i></td>
<td><i>Journal of Bible and Religion</i></td>
</tr>
<tr>
<td><i>JETS</i></td>
<td><i>Journal of the Evangelical Theological Society</i></td>
</tr>
<tr>
<td><i>JJS</i></td>
<td><i>Journal of Jewish Studies</i></td>
</tr>
<tr>
<td><i>JR</i></td>
<td><i>Journal of Religion</i></td>
</tr>
<tr>
<td><i>JSNT</i></td>
<td><i>Journal for the Study of the New Testament</i></td>
</tr>
<tr>
<td><i>JTS</i></td>
<td><i>Journal of Theological Studies</i></td>
</tr>
<tr>
<td><i>NCB</i></td>
<td><i>New Century Bible Commentary</i></td>
</tr>
<tr>
<td><i>NIBC</i></td>
<td><i>New International Bible Commentary</i></td>
</tr>
<tr>
<td><i>NIC</i></td>
<td><i>New International Commentary</i></td>
</tr>
<tr>
<td>NT</td>
<td>(in titles) New Testament</td>
</tr>
<tr>
<td><i>NT</i></td>
<td><i>Novum Testamentum</i></td>
</tr>
<tr>
<td><i>NTS</i></td>
<td><i>New Testament Studies</i></td>
</tr>
<tr>
<td>OT</td>
<td>(in titles) Old Testament</td>
</tr>
<tr>
<td><i>PSTJ</i></td>
<td><i>Perkins School of Theology Journal</i></td>
</tr>
<tr>
<td><i>RefTR</i></td>
<td><i>Reformed Theological Review</i></td>
</tr>
<tr>
<td><i>ResQ</i></td>
<td><i>Restoration Quarterly</i></td>
</tr>
<tr>
<td><i>Rev and Exp</i></td>
<td><i>Review and Expositor</i></td>
</tr>
<tr>
<td><i>RGG</i></td>
<td><i>Religion in Geschichte und Gegenwart</i></td>
</tr>
<tr>
<td><i>RQ</i></td>
<td><i>Revue de Qumran</i></td>
</tr>
<tr>
<td><i>RSR</i></td>
<td><i>Recherches de science religieuse</i></td>
</tr>
<tr>
<td><i>SB</i></td>
<td><i>Scripture Bulletin</i></td>
</tr>
<tr>
<td><i>SJTh</i></td>
<td><i>Scottish Journal of Theology</i></td>
</tr>
<tr>
<td><i>StEv</i></td>
<td><i>Studia Evangelica</i></td>
</tr>
<tr>
<td><i>StTh</i></td>
<td><i>Studia Theologica</i></td>
</tr>
<tr>
<td><i>SWJT</i></td>
<td><i>Southwestern Journal of Theology</i></td>
</tr>
<tr>
<td><i>TB</i></td>
<td><i>Tyndale Bulletin</i></td>
</tr>
<tr>
<td><i>TDNT</i></td>
<td><i>Theological Dictionary of the New Testament</i> (Kittel)</td>
</tr>
<tr>
<td><i>ThSt</i></td>
<td><i>Theological Studies</i></td>
</tr>
<tr>
<td><i>Th Today</i></td>
<td><i>Theology Today</i></td>
</tr>
<tr>
<td><i>TLZ</i></td>
<td><i>Theologische Literaturzeitung</i></td>
</tr>
<tr>
<td><i>TZ</i></td>
<td><i>Theologische Zeitschrift</i></td>
</tr>
<tr>
<td><i>USQR</i></td>
<td><i>Union Seminary Quarterly Review</i></td>
</tr>
<tr>
<td><i>Vig Chr</i></td>
<td><i>Vigiliae Christianae</i></td>
</tr>
<tr>
<td><i>WBC</i></td>
<td><i>Word Biblical Commentary</i></td>
</tr>
<tr>
<td><i>WThJ</i></td>
<td><i>Westminster Theological Journal</i></td>
</tr>
<tr>
<td><i>WW</i></td>
<td><i>Word and World</i></td>
</tr>
<tr>
<td><i>ZNTW</i></td>
<td><i>Zeitschrift für die neutestamentliche Wissenschaft</i></td>
</tr>
<tr>
<td><i>ZSysTh</i></td>
<td><i>Zeitschrift für Systematische Theologie</i></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?1e4f0232